/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Artenova — card della Wishlist (app Wishlist King).
     I componenti sono Lit in light DOM: si modificano solo i dati dei nodi di testo
     (mai textContent/innerHTML) così i marker di Lit restano validi ai re-render. */
  var CTA_LABEL = 'Aggiungi al carrello';
  var SIZE_PLACEHOLDER = 'Seleziona dimensione';
  // mostrato dentro il selettore: non aggiunge altezza e non disallinea le card vicine
  var SIZE_MESSAGE = 'Scegli la dimensione';

  function textNodes(el) {
    var nodes = [];
    if (!el) return nodes;
    el.childNodes.forEach(function (node) {
      if (node.nodeType === 3 && node.data.trim()) nodes.push(node);
    });
    return nodes;
  }

  function setText(el, value) {
    var nodes = textNodes(el);
    if (!nodes.length) return;
    if (nodes[0].data.trim() !== value) nodes[0].data = value;
    for (var i = 1; i < nodes.length; i++) nodes[i].data = '';
  }

  // Prezzi in formato italiano: "€1.250,00 EUR" / "€550.00 EUR" -> "1.250 €", "€89,90" -> "89,90 €"
  function formatPrice(text) {
    return text.replace(/€\s*(\d[\d.,]*)(?:\s*EUR)?/g, function (match, amount) {
      var parts = amount.match(/^(.*?)(?:[.,](\d{2}))?$/);
      var units = parts[1].replace(/[.,]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var cents = parts[2];
      return units + (cents && cents !== '00' ? ',' + cents : '') + ' €';
    });
  }

  function formatPricesIn(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.data.indexOf('€') === -1) continue;
      var formatted = formatPrice(node.data);
      if (formatted !== node.data) node.data = formatted;
    }
  }

  function hasVariant(form) {
    var input = form && form.querySelector('input[name="id"]');
    return Boolean(input && input.value);
  }

  function enhanceCard(card) {
    card.querySelectorAll('.wk-current-price, .wk-compare-price, .wk-unit-price').forEach(formatPricesIn);

    var form = card.querySelector('.wk-form');
    if (!form) return;
    var selected = hasVariant(form);

    if (!selected) {
      var placeholder = card.classList.contains('artenova-wk-needs-size') ? SIZE_MESSAGE : SIZE_PLACEHOLDER;
      form.querySelectorAll('wk-option-select .wk-text').forEach(function (text) {
        setText(text, placeholder);
      });
    }

    var button = form.querySelector('.wk-cta-button');
    if (button && !selected) {
      setText(button.querySelector('.wk-cta-label'), CTA_LABEL);
      if (button.disabled) button.disabled = false;
    }

    if (selected && card.classList.contains('artenova-wk-needs-size')) {
      card.classList.remove('artenova-wk-needs-size');
      var select = form.querySelector('wk-option-select select');
      if (select) select.removeAttribute('aria-invalid');
    }
  }

  function showSizeMessage(form) {
    var card = form.closest('wishlist-product-card');
    if (!card) return;
    card.classList.remove('artenova-wk-needs-size');
    void card.offsetWidth; // riavvia l'animazione a ogni click
    card.classList.add('artenova-wk-needs-size');
    enhanceCard(card);

    var select = form.querySelector('wk-option-select select');
    if (!select) return;
    select.setAttribute('aria-invalid', 'true');
    select.focus({preventScroll: true});
    // apre subito l'elenco delle misure dove supportato (Chrome/Android); altrove resta il messaggio
    try { if (select.showPicker) select.showPicker(); } catch (e) {}
  }

  function blockWithoutSize(event) {
    var form = event.target.closest && event.target.closest('wishlist-product-card .wk-form');
    if (!form) return;
    if (event.type === 'click' && !event.target.closest('.wk-cta-button')) return;
    if (hasVariant(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showSizeMessage(form);
  }

  document.addEventListener('click', blockWithoutSize, true);
  document.addEventListener('submit', blockWithoutSize, true);
  document.addEventListener('change', function (event) {
    var card = event.target.closest && event.target.closest('wishlist-product-card');
    if (card) setTimeout(function () { enhanceCard(card); }, 0);
  }, true);

  /* Artenova — carrello (drawer del tema): prezzi, spedizione gratuita sopra soglia */
  var CART_PRICE_SELECTORS = '.cart__item__price, .cart__total, .cart__discount, .cart__checkout, .cart-message, .artenova-cart-info';

  function enhanceCart(drawer) {
    drawer.querySelectorAll(CART_PRICE_SELECTORS).forEach(formatPricesIn);

    var totalEl = drawer.querySelector('[data-cart-total]');
    var total = totalEl ? parseInt(totalEl.getAttribute('data-cart-total'), 10) : NaN;
    if (isNaN(total)) return;
    drawer.querySelectorAll('[data-artenova-cart-shipping]').forEach(function (row) {
      var isFree = total >= parseInt(row.getAttribute('data-limit'), 10);
      if (row.classList.contains('is-free') !== isFree) row.classList.toggle('is-free', isFree);
    });
  }

  /* Artenova — header: contatore articoli sul carrello e cuore preferiti accanto alla ricerca */
  var HEART_SVG = '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5S3.8 15.4 3.8 9.9A4.6 4.6 0 0 1 12 7.2a4.6 4.6 0 0 1 8.2 2.7c0 5.5-8.2 10.6-8.2 10.6z"/></svg>';
  var cartCount = null;

  function paintCartCount(count) {
    document.querySelectorAll('.cart__toggle').forEach(function (toggle) {
      var badge = toggle.querySelector('.artenova-cart-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'artenova-cart-count';
        badge.setAttribute('aria-hidden', 'true');
        toggle.appendChild(badge);
      }
      var label = count > 99 ? '99+' : String(count);
      if (badge.textContent !== label) badge.textContent = label;
      if (badge.hidden !== (count < 1)) badge.hidden = count < 1;
    });
  }

  function setCartCount(count) {
    if (typeof count !== 'number' || isNaN(count) || count === cartCount) return;
    cartCount = count;
    paintCartCount(count);
  }

  function refreshCartCount() {
    fetch('/cart.js', {headers: {Accept: 'application/json'}})
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { if (cart) setCartCount(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-cart-drawer-toggle], .product__submit__add, [data-artenova-sticky-add], [data-artenova-installments], [data-item-remove], [data-quantity-button], .wk-cta-button');
    if (!target) return;
    setTimeout(refreshCartCount, 900);
    setTimeout(refreshCartCount, 2200);
  });

  function isVisible(el) {
    return Boolean(el && el.getBoundingClientRect().width);
  }

  // Il tema ha più varianti di header (desktop, tablet, mobile): il cuore va accanto
  // a ogni carrello, e resta nascosto dove l'app mostra già il suo link ai preferiti.
  function ensureHeaderWishlist() {
    document.querySelectorAll('.site-header .cart__toggle').forEach(function (cartToggle) {
      var previous = cartToggle.previousElementSibling;
      if (previous && previous.classList.contains('artenova-header-wishlist')) return;
      var link = document.createElement('a');
      link.className = cartToggle.classList.contains('navlink')
        ? 'navlink navlink--icon artenova-header-wishlist'
        : 'mobile-menu__button artenova-header-wishlist';
      link.href = '/apps/wishlist';
      link.setAttribute('aria-label', 'Apri i preferiti');
      link.innerHTML = HEART_SVG;
      cartToggle.parentNode.insertBefore(link, cartToggle);
    });

    var appLink = document.querySelector('.site-header .wishlist-header-link');
    var appLinkVisible = isVisible(appLink);
    document.querySelectorAll('.artenova-header-wishlist').forEach(function (link) {
      if (link.hidden !== appLinkVisible) link.hidden = appLinkVisible;
    });
  }

  var queued = false;
  function enhanceAll() {
    queued = false;
    document.querySelectorAll('wishlist-product-card').forEach(enhanceCard);
    document.querySelectorAll('cart-element').forEach(enhanceCart);
    ensureHeaderWishlist();
    if (cartCount !== null) paintCartCount(cartCount);
    var qty = document.querySelector('[data-cart-items-qty]:not([class*="hidden"])');
    var fromDrawer = qty ? parseInt((qty.textContent.match(/\d+/) || [])[0], 10) : NaN;
    if (!isNaN(fromDrawer)) setCartCount(fromDrawer);
  }
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(enhanceAll, 30);
  }).observe(document.documentElement, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'value', 'data-cart-total']});
  enhanceAll();
  refreshCartCount();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
